// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HNpF","label":"styles_label__11RuV"};